import { render } from "./auth-form.vue?vue&type=template&id=2401f498"
import script from "./auth-form.vue?vue&type=script&lang=js"
export * from "./auth-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/auth-form/auth-form.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2401f498"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2401f498', __exports__)) {
    api.reload('2401f498', __exports__)
  }
  
  module.hot.accept("./auth-form.vue?vue&type=template&id=2401f498", () => {
    api.rerender('2401f498', render)
  })

}


export default __exports__